import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  WithStyles,
  withStyles,
  Divider,
  Typography,
  MenuItem,
  ListItemText,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import * as React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { colors } from "../constants/constants";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { AuthConsumer } from "../routes/AuthContext";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_ACTION: "DIALOG_ACTION",
};
const styles = () =>
  createStyles({
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff",
    },
  });
const addVisitorValidationSchema = Yup.object().shape({
  fullName: Yup.string().required("Full name is required"),
  identityNumber: Yup.string().when("passportDocument", {
    is: true,
    then: Yup.string(),
    otherwise: Yup.string()
      .min(13)
      .max(13)
      .required("Identity number is required"),
  }),
  passportNumber: Yup.string().when("passportDocument", {
    is: true,
    then: Yup.string().required("Passport number is required"),
    otherwise: Yup.string(),
  }),
  department: Yup.string().required("Select your department"),
});
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  visitors: any;
  handleClose: any;
  editData: any;
  company: any;
  handleOnSubmit: any;
}

class AddVisitorDialog extends React.Component<Props> {
  state = {
    showPassword: false,
    hasError: false,
    selectedDate: new Date(),
    licenseDetails: Array<any>(),
    selectedLicenseDetailItem: { licenseNumber: "" },
    selectedIndex: -1,
    openAddLicenseDetailDialog: false,
  };
  componentDidMount = () => {
    const { editData } = this.props;
    if (editData && editData.fullName) {
    }
  };

  componentDidUpdate(prevProps: any, prevState: any) {
    const { editData } = this.props;
    if (prevProps.editData !== editData) {
      if (editData && editData.fullName) {
      }
    }
  }
  handleOnAuoSelectItemSelected = (id: any, value: any, setFieldValue: any) => {
    setFieldValue(id, value);
  };

  handleOnEmployeeSelected = (
    event: any,
    value: any,
    id: any,
    setFieldValue: any
  ) => {
    setFieldValue(id, value);
  };
  renderAutoSelect = (
    type: String,
    id: any,
    value: any,
    handleChange: any,
    handleBlur: any,
    name: any,
    label: any,
    error: any,
    errors: any,
    setFieldValue: any,
    selections?: any
  ) => {
    return (
      <Autocomplete
        multiple
        id={id}
        freeSolo
        options={selections}
        defaultValue={
          this.props.editData && this.props.editData.fullName
            ? this.props.editData.authorizeEquipments
            : []
        }
        onChange={(event: any, value: any) =>
          this.handleOnEmployeeSelected(event, value, id, setFieldValue)
        }
        renderOption={(option: any) => (
          <React.Fragment>
            <ListItemText primary={option.name} secondary={option.subtitle} />
          </React.Fragment>
        )}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            margin="normal"
            variant="outlined"
            placeholder={"Add Authorized Equipments"}
            style={{ width: "100%" }}
          />
        )}
      />
    );
  };

  renderTextInput = (
    type: String,
    id: any,
    value: any,
    handleChange: any,
    handleBlur: any,
    name: any,
    label: any,
    error: any,
    selections?: any
  ) => {
    return (
      <div>
        {type === "text" && (
          <TextField
            style={{ margin: 10 }}
            id={id}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            name={name}
            label={label}
            inputProps={
              id === "phone"
                ? { maxLength: 10 }
                : id === "identityNumber"
                ? { maxLength: 13 }
                : { maxLength: 170 }
            }
            fullWidth
          />
        )}
        {type === "select" && (
          <TextField
            style={{ margin: 10 }}
            select
            id={id}
            label={label}
            margin="dense"
            value={value ? value : ""}
            onChange={handleChange(id)}
            fullWidth
          >
            {selections.map((option: any) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        )}
        <Typography
          variant={"subtitle1"}
          align={"right"}
          style={{
            color: "red",
            alignSelf: "right",
          }}
        >
          {error}
        </Typography>
      </div>
    );
  };
  renderAllInputField = (
    values: any,
    handleChange: any,
    handleBlur: any,
    errors: any,
    touched: any,
    setFieldValue: any
  ) => {
    return (
      <div>
        {this.renderTextInput(
          "text",
          "fullName",
          values.fullName,
          handleChange,
          handleBlur,
          "fullName",
          "Full Name",
          errors.fullName
        )}
        <FormControlLabel
          label="Passport Number"
          control={
            <Checkbox
              id={"passportDocument"}
              name={"passportDocument"}
              checked={values.passportDocument}
              onChange={(event: any) => {
                setFieldValue("passportDocument", event.target.checked);
              }}
              value="Passport Number"
            />
          }
        />
        {!values.passportDocument &&
          this.renderTextInput(
            "text",
            "identityNumber",
            values.identityNumber,
            handleChange,
            handleBlur,
            "identityNumber",
            "Identity Number",
            errors.identityNumber
          )}
        {values.passportDocument &&
          this.renderTextInput(
            "text",
            "passportNumber",
            values.passportNumber,
            handleChange,
            handleBlur,
            "passportNumber",
            "Passport Number",
            errors.passportNumber
          )}
        {
          <div>
            <Autocomplete
              id={"department"}
              freeSolo
              options={
                this.props.company && this.props.company.departments
                  ? this.props.company.departments
                  : new Array<any>()
              }
              value={values.department}
              onChange={(event: any, value: any) =>
                this.handleOnAuoSelectItemSelected(
                  "department",
                  value,
                  setFieldValue
                )
              }
              getOptionLabel={(option: any) =>
                option && option.title ? option.title : ""
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Department"
                  margin="normal"
                  variant="outlined"
                  placeholder={"Search department"}
                  style={{ width: "100%" }}
                />
              )}
            />
            {this.renderTextInput(
              "text",
              "companyName",
              values.companyName,
              handleChange,
              handleBlur,
              "companyName",
              "Company Name",
              errors.companyName
            )}
            <Typography
              variant={"subtitle1"}
              align={"right"}
              style={{
                color: "red",
                alignSelf: "right",
              }}
            >
              {errors.department}
            </Typography>
          </div>
        }
      </div>
    );
  };
  handleOnEditSubmit = (values: any) => {
    this.handleClose();
    if (this.state.selectedIndex > -1 && this.state.selectedLicenseDetailItem) {
      let licenseDetailsList = this.state.licenseDetails;
      licenseDetailsList[this.state.selectedIndex] = values;
      this.setState({
        licenseDetailsList: licenseDetailsList,
        selectedIndex: -1,
        selectedLicenseDetailItem: {},
      });
    }
  };
  handleOnSubmit = (values: any) => {
    this.handleClose();
    let licenseDetailsList = this.state.licenseDetails;
    licenseDetailsList.push(values);
    this.setState({
      licenseDetails: licenseDetailsList,
    });
  };

  handleOnAddVisitorSubmit = (values: any, user: any, accessRules: any) => {
    const { handleOnSubmit } = this.props;
    if (values.passportDocument) {
      values.identityNumber = "";
    } else {
      values.passportNumber = "";
    }
    handleOnSubmit(values, user, accessRules);
  };

  handleClose = () => {
    this.setState({
      openAddLicenseDetailDialog: false,
    });
  };
  render() {
    const { open, handleClose, title, editData } = this.props;
    return (
      <React.Fragment>
        <AuthConsumer>
          {({ user, accessRules }) => (
            <div>
              <Dialog
                open={open}
                keepMounted={true}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                fullWidth={true}
                maxWidth={"md"}
              >
                <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
                <Divider />
                <DialogContent>
                  <Formik
                    initialValues={
                      editData && editData.fullName
                        ? editData
                        : {
                            fullName: "",
                            passportDocument: false,
                            identityNumber: "",
                            passportNumber: "",
                            department: "",
                            companyName: "",
                          }
                    }
                    enableReinitialize={true}
                    validationSchema={addVisitorValidationSchema}
                    onSubmit={(values) => {}}
                  >
                    {({
                      values,
                      handleChange,
                      handleBlur,
                      handleReset,
                      handleSubmit,
                      errors,
                      isValid,
                      touched,
                      setFieldValue,
                    }) => (
                      <Form>
                        <div>
                          {this.renderAllInputField(
                            values,
                            handleChange,
                            handleBlur,
                            errors,
                            touched,
                            setFieldValue
                          )}
                          <DialogActions>
                            <Button
                              onClick={() => {
                                handleReset();
                                handleClose();
                              }}
                            >
                              {"CANCEL"}
                            </Button>
                            <Button
                              type="submit"
                              disabled={!isValid}
                              onClick={() => {
                                this.handleOnAddVisitorSubmit(
                                  values,
                                  user,
                                  accessRules
                                );
                                handleReset();
                              }}
                            >
                              {"SUBMIT"}
                            </Button>
                          </DialogActions>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </DialogContent>
              </Dialog>
            </div>
          )}
        </AuthConsumer>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddVisitorDialog);
